import { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Tooltip from '@mui/material/Tooltip';

const EvaluationOfAdvisor = ({index, advisor, evaluation, setEvaluation, dropEvaluation, validating, handleEoAErrors, disabled=false}) => {
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        validateEoA();
    }, []);

    function displayTerm(term) {
        if (term === -1) return "Now";
        let s = term%100 === 1 ? "Spring " : term%100 === 9 ? "Fall " : "";
        let y = String(Math.floor(term/100));
        if(!s || y === "0")
            return "???";
        return s+y;
    }

    const validateEoA = () => {
        let newErrors = {};
        console.log(`[EoA] Validating? `,validating);
        if(!validating) {
            console.log(`[EoA] checking lengths?`)
            if(evaluation.meeting_frequency.length > 2000)
                newErrors.meeting_frequency = "Answer must be 2000 characters or less"
            if(evaluation.timely_feedback_text.length > 2000)
                newErrors.timely_feedback_text = "Answer must be 2000 characters or less"
            if(evaluation.professional_development_text.length > 2000)
                newErrors.professional_development_text = "Answer must be 2000 characters or less"
            if(evaluation.approachability_text.length > 2000)
                newErrors.approachability_text = "Answer must be 2000 characters or less"
            if(evaluation.expectations_and_goals_text.length > 2000)
                newErrors.expectations_and_goals_text = "Answer must be 2000 characters or less"
            if(evaluation.overall_satisfaction_text.length > 2000)
                newErrors.overall_satisfaction_text = "Answer must be 2000 characters or less"
            if(evaluation.additional_info.length > 2000)
                newErrors.additional_info = "Answer must be 2000 characters or less"
        } else {
            if(evaluation.meeting_frequency === "" || evaluation.meeting_frequency.trim() === '<p><br></p>')
                newErrors.meeting_frequency = "You must answer this question"
            else if(evaluation.meeting_frequency.length > 2000)
                newErrors.meeting_frequency = "Answer must be 2000 characters or less"
            if(evaluation.timely_feedback_value === null)
                newErrors.timely_feedback_value = "You must answer this question"
            if(evaluation.professional_development_value === null)
                newErrors.professional_development_value = "You must answer this question"
            if(evaluation.approachability_value === null)
                newErrors.approachability_value = "You must answer this question"
            if(evaluation.expectations_and_goals_value === null)
                newErrors.expectations_and_goals_value = "You must answer this question"
            if( evaluation.overall_satisfaction_value === null)
                newErrors.overall_satisfaction_value = "You must answer this question"
            if(evaluation.follow_up === null)
                newErrors.follow_up = "You must answer this question"
            if(evaluation.timely_feedback_text.length > 2000)
                newErrors.timely_feedback_text = "Answer must be 2000 characters or less"
            if(evaluation.professional_development_text.length > 2000)
                newErrors.professional_development_text = "Answer must be 2000 characters or less"
            if(evaluation.approachability_text.length > 2000)
                newErrors.approachability_text = "Answer must be 2000 characters or less"
            if(evaluation.expectations_and_goals_text.length > 2000)
                newErrors.expectations_and_goals_text = "Answer must be 2000 characters or less"
            if(evaluation.overall_satisfaction_text.length > 2000)
                newErrors.overall_satisfaction_text = "Answer must be 2000 characters or less"
            if(evaluation.additional_info.length > 2000)
                newErrors.additional_info = "Answer must be 2000 characters or less"
        }
        setErrors(newErrors);
        console.log(`[EoA]`,newErrors);
        handleEoAErrors(index, Object.keys(newErrors).length);
    }

    useEffect(() => {
        validateEoA();
    }, [evaluation, validating]);

    if(!!evaluation || Object.keys(evaluation) > 0)
    return (
        <fieldset>
            <legend>
                Evaluation of {advisor?.first} {advisor?.last} ({displayTerm(advisor.start)} - {displayTerm(advisor.end)})
                {advisor.end !== -1 && <>
                    &nbsp;
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => dropEvaluation(index)}
                    >Delete</button>
                </>}
            </legend>
            <ol>
                <li> {/* Meeting Frequency */}
                    <p htmlFor={`eoa.${index}.meeting_frequency`}>How often do you meet with your advisor?</p>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.meeting_frequency}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.meeting_frequency`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.meeting_frequency.length > 2000 && "red", fontWeight: evaluation.meeting_frequency.length >= 1900 && "bold"}}>{evaluation.meeting_frequency.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.meeting_frequency /*&& validating*/ &&
                        <span className="feedback">{errors.meeting_frequency}</span>
                    }
                </li>
                <li> {/* Timely Feedback */}
                    <p>Do you feel like your advisor provides timely and constructive feedback?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Always`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={4}
                                checked={evaluation.timely_feedback_value === 4}
                                onChange={(e) => {if(disabled){}else setEvaluation(e)}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Always`}>Always</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Often`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={3}
                                checked={evaluation.timely_feedback_value === 3}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Often`}>Often</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Sometimes`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={2}
                                checked={evaluation.timely_feedback_value === 2}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Rarely`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={1}
                                checked={evaluation.timely_feedback_value === 1}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Rarely`}>Rarely</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Never`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={0}
                                checked={evaluation.timely_feedback_value === 0}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Never`}>Never</label>
                        </div>
                    </div>
                    {errors?.timely_feedback_value /*&& validating*/ &&
                        <span className="feedback">{errors.timely_feedback_value}</span>
                    }
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.timely_feedback_text}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.timely_feedback_text`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                        placeholder="Optional place to provide further explanation."
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.timely_feedback_text.length > 2000 && "red", fontWeight: evaluation.timely_feedback_text.length >= 1900 && "bold"}}>{evaluation.timely_feedback_text.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.timely_feedback_text /*&& validating*/ &&
                        <span className="feedback">{errors.timely_feedback_text}</span>
                    }
                </li>
                <li> {/* Professional Development */}
                    <p>Does your advisor support your professional development (e.g., career planning, conference attendance)?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.professional_development-Yes`}
                                name={`eoa.${index}.professional_development_value`}
                                value={2}
                                checked={evaluation.professional_development_value === 2}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.professional_development-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.professional_development-Sometimes`}
                                name={`eoa.${index}.professional_development_value`}
                                value={1}
                                checked={evaluation.professional_development_value === 1}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.professional_development-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.professional_development-No`}
                                name={`eoa.${index}.professional_development_value`}
                                value={0}
                                checked={evaluation.professional_development_value === 0}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.professional_development-No`}>No</label>
                        </div>
                    </div>
                    {errors?.professional_development_value /*&& validating*/ &&
                        <span className="feedback">{errors.professional_development_value}</span>
                    }
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.professional_development_text}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.professional_development_text`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                        placeholder="Optional place to provide further explanation."
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.professional_development_text.length > 2000 && "red", fontWeight: evaluation.professional_development_text.length >= 1900 && "bold"}}>{evaluation.professional_development_text.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.professional_development_text /*&& validating*/ &&
                        <span className="feedback">{errors.professional_development_text}</span>
                    }
                </li>
                <li> {/* Approachability */}
                    <p>Do you feel comfortable approaching your advisor for help when needed?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.approachability-Yes`}
                                name={`eoa.${index}.approachability_value`}
                                value={2}
                                checked={evaluation.approachability_value === 2}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.approachability-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.approachability-Sometimes`}
                                name={`eoa.${index}.approachability_value`}
                                value={1}
                                checked={evaluation.approachability_value === 1}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.approachability-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.approachability-No`}
                                name={`eoa.${index}.approachability_value`}
                                value={0}
                                checked={evaluation.approachability_value === 0}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.approachability-No`}>No</label>
                        </div>
                    </div>
                    {errors?.approachability_value /*&& validating*/ &&
                        <span className="feedback">{errors.approachability_value}</span>
                    }
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.approachability_text}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.approachability_text`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                        placeholder="Optional place to provide further explanation."
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.approachability_text.length > 2000 && "red", fontWeight: evaluation.approachability_text.length >= 1900 && "bold"}}>{evaluation.approachability_text.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.approachability_text /*&& validating*/ &&
                        <span className="feedback">{errors.approachability_text}</span>
                    }
                </li>
                <li> {/* Expectations and Goals */}
                    <p>Has your advisor helped you set clear expectations and goals for your research?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.expectations_and_goals-Yes`}
                                name={`eoa.${index}.expectations_and_goals_value`}
                                value={2}
                                checked={evaluation.expectations_and_goals_value === 2}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.expectations_and_goals-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.expectations_and_goals-Sometimes`}
                                name={`eoa.${index}.expectations_and_goals_value`}
                                value={1}
                                checked={evaluation.expectations_and_goals_value === 1}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.expectations_and_goals-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.expectations_and_goals-No`}
                                name={`eoa.${index}.expectations_and_goals_value`}
                                value={0}
                                checked={evaluation.expectations_and_goals_value === 0}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.expectations_and_goals-No`}>No</label>
                        </div>
                    </div>
                    {errors?.expectations_and_goals_value /*&& validating*/ &&
                        <span className="feedback">{errors.expectations_and_goals_value}</span>
                    }
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.expectations_and_goals_text}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.expectations_and_goals_text`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                        placeholder="Optional place to provide further explanation."
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.expectations_and_goals_text.length > 2000 && "red", fontWeight: evaluation.expectations_and_goals_text.length >= 1900 && "bold"}}>{evaluation.expectations_and_goals_text.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.expectations_and_goals_text /*&& validating*/ &&
                        <span className="feedback">{errors.expectations_and_goals_text}</span>
                    }
                </li>
                <li> {/* Overall Satisfaction */}
                    <p>Overall, how satisfied are you with your advising relationship?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Very_Satisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={4}
                                checked={evaluation.overall_satisfaction_value === 4}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Very_Satisfied`}>Very Satisfied</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Satisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={3}
                                checked={evaluation.overall_satisfaction_value === 3}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Satisfied`}>Satisfied</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Neutral`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={2}
                                checked={evaluation.overall_satisfaction_value === 2}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Neutral`}>Neutral</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Dissatisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={1}
                                checked={evaluation.overall_satisfaction_value === 1}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Dissatisfied`}>Dissatisfied</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Very_Dissatisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={0}
                                checked={evaluation.overall_satisfaction_value === 0}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Very_Dissatisfied`}>Very Dissatisfied</label>
                        </div>
                    </div>
                    {errors?.overall_satisfaction_value /*&& validating*/ &&
                        <span className="feedback">{errors.overall_satisfaction_value}</span>
                    }
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.overall_satisfaction_text}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.overall_satisfaction_text`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                        placeholder="Optional place to provide further explanation."
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.overall_satisfaction_text.length > 2000 && "red", fontWeight: evaluation.overall_satisfaction_text.length >= 1900 && "bold"}}>{evaluation.overall_satisfaction_text.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.overall_satisfaction_text /*&& validating*/ &&
                        <span className="feedback">{errors.overall_satisfaction_text}</span>
                    }
                </li>
                <li>
                    <p htmlFor={`eoa.${index}.additional_info`}>
                        Please share any additional information about your advising relationship or experience that you would like the Graduate Program Office to know:
                    </p>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.additional_info}
                        onChange={(value) => setEvaluation({target:{
                            name: `eoa.${index}.additional_info`,
                            type: "text",
                            value,
                            checked: false,
                        }})}
                        modules={{toolbar: [
                            ['bold', 'italic', 'underline'], 
                            [{ list: 'ordered' }, { list: 'bullet' }], 
                            ['link'], 
                        ],}}
                        placeholder="Optional place to provide further explanation."
                    />
                    <div style={{textAlign:"right"}}>
                        <Tooltip title="Styling takes up extra characters">
                            <span style={{color: evaluation.additional_info.length > 2000 && "red", fontWeight: evaluation.additional_info.length >= 1900 && "bold"}}>{evaluation.additional_info.length}/2000*</span>
                        </Tooltip>
                    </div>
                    {errors?.additional_info /*&& validating*/ &&
                        <span className="feedback">{errors.additional_info}</span>
                    }
                </li>
                <li>
                    <p htmlFor={`eoa.${index}.follow_up`}>
                        Would you like someone from the Graduate Program Office to follow up with you directly?
                    </p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.follow_up-Yes`}
                                name={`eoa.${index}.follow_up`}
                                value={1}
                                checked={evaluation.follow_up === 1}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.follow_up-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.follow_up-No`}
                                name={`eoa.${index}.follow_up`}
                                value={0}
                                checked={evaluation.follow_up === 0}
                                onChange={setEvaluation}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.follow_up-No`}>No</label>
                        </div>
                    </div>
                    {errors?.follow_up /*&& validating*/ &&
                        <span className="feedback">{errors.follow_up}</span>
                    }
                </li>
            </ol>
        </fieldset>
    );
    else return <></>
}

export default EvaluationOfAdvisor;